module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("AP印刷 : " + _vm._s(_vm.user.user) + " ｜ 訪問日 : " + _vm._s(_vm.appointment.visit_date) + " / " + _vm._s(_vm.appointment.visit_time))]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("希望曜日 : " + _vm._s(_vm.appointment.request_of_day_of_week) + " / "), _c('span', [_vm._v(_vm._s(_vm.appointment.request_of_day_of_week_note))])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("媒体")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.medium1 === 1) ? [_vm._v("DM")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 2) ? [_vm._v("貼紙")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 3) ? [_vm._v("HP")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 4) ? [_vm._v("紹介")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 5) ? [_vm._v("TEL注")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 6) ? [_vm._v("TA")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium1 === 7) ? [_vm._v("その他")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 1) ? [_vm._v("DM")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 2) ? [_vm._v("貼紙")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 3) ? [_vm._v("HP")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 4) ? [_vm._v("紹介")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 5) ? [_vm._v("TEL注")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 6) ? [_vm._v("TA")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium2 === 7) ? [_vm._v("その他")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 1) ? [_vm._v("DM")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 2) ? [_vm._v("貼紙")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 3) ? [_vm._v("HP")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 4) ? [_vm._v("紹介")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 5) ? [_vm._v("TEL注")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 6) ? [_vm._v("TA")] : _vm._e(), _vm._v(" "), (_vm.appointment.medium3 === 7) ? [_vm._v("その他")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("AP種類")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.ap_type === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.appointment.ap_type === 1) ? [_vm._v("体験希望")] : _vm._e(), _vm._v(" "), (_vm.appointment.ap_type === 2) ? [_vm._v("資料請求")] : _vm._e(), _vm._v(" "), (_vm.appointment.ap_type === 3) ? [_vm._v("問い合わせ")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("HP種類")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.hp_type === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.appointment.hp_type === 1) ? [_vm._v("自社")] : _vm._e(), _vm._v(" "), (_vm.appointment.hp_type === 2) ? [_vm._v("リスティング")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("訪問日時")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.visit_date) + " / " + _vm._s(_vm.appointment.visit_time))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("AP応対者 / 相手")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('span', [_vm._v(_vm._s(_vm.appointment.person))]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.contact_person === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 1) ? _c('span', [_vm._v("母")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 2) ? _c('span', [_vm._v("父")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 3) ? _c('span', [_vm._v("祖母")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 4) ? _c('span', [_vm._v("祖父")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 5) ? _c('span', [_vm._v("本人")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 6) ? _c('span', [_vm._v("伯母")]) : _vm._e(), _vm._v(" "), (_vm.appointment.contact_person === 7) ? _c('span', [_vm._v("伯父")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("名前")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.f_name) + " " + _vm._s(_vm.appointment.l_name))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("かな")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.f_name_kana) + " " + _vm._s(_vm.appointment.l_name_kana))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("住所")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("\n          " + _vm._s(_vm.appointment.zip)), _c('br'), _vm._v(" "), (_vm.appointment.pref === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 1) ? [_vm._v("北海道")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 2) ? [_vm._v("青森県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 3) ? [_vm._v("秋田県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 4) ? [_vm._v("岩手県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 5) ? [_vm._v("山形県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 6) ? [_vm._v("宮城県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 7) ? [_vm._v("福島県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 8) ? [_vm._v("栃木県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 9) ? [_vm._v("山梨県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 10) ? [_vm._v("群馬県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 11) ? [_vm._v("茨城県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 12) ? [_vm._v("千葉県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 13) ? [_vm._v("埼玉県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 14) ? [_vm._v("東京都")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 15) ? [_vm._v("神奈川県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 16) ? [_vm._v("静岡県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 17) ? [_vm._v("長野県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 18) ? [_vm._v("愛知県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 19) ? [_vm._v("岐阜県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 20) ? [_vm._v("新潟県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 21) ? [_vm._v("富山県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 22) ? [_vm._v("石川県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 23) ? [_vm._v("福井県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 24) ? [_vm._v("滋賀県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 25) ? [_vm._v("京都府")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 26) ? [_vm._v("三重県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 27) ? [_vm._v("和歌山県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 28) ? [_vm._v("奈良県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 29) ? [_vm._v("大阪府")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 30) ? [_vm._v("兵庫県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 31) ? [_vm._v("鳥取県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 32) ? [_vm._v("島根県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 33) ? [_vm._v("岡山県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 34) ? [_vm._v("広島県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 35) ? [_vm._v("山口県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 36) ? [_vm._v("高知県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 37) ? [_vm._v("徳島県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 38) ? [_vm._v("香川県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 39) ? [_vm._v("愛媛県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 40) ? [_vm._v("福岡県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 41) ? [_vm._v("佐賀県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 42) ? [_vm._v("長崎県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 43) ? [_vm._v("熊本県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 44) ? [_vm._v("宮崎県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 45) ? [_vm._v("大分県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 46) ? [_vm._v("鹿児島県")] : _vm._e(), _vm._v(" "), (_vm.appointment.pref === 47) ? [_vm._v("沖縄県")] : _vm._e(), _vm._v("\n          " + _vm._s(_vm.appointment.address1) + " " + _vm._s(_vm.appointment.address2) + "\n        ")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("TEL1")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.tel1))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("TEL2")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.tel2))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("前日確認TEL連絡先")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.preferred_contact === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.preferred_contact === 1) ? _c('span', [_vm._v("自宅")]) : _vm._e(), _vm._v(" "), (_vm.appointment.preferred_contact === 2) ? _c('span', [_vm._v("携帯")]) : _vm._e(), _vm._v(" "), (_vm.appointment.preferred_contact === 3) ? _c('span', [_vm._v("勤務先")]) : _vm._e(), _vm._v(" "), (_vm.appointment.preferred_contact === 4) ? _c('span', [_vm._v("その他")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("時間帯")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.contact_timezone))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("学校名 / 学年 / 性別")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.school_type === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_type === 1) ? _c('span', [_vm._v("公立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_type === 2) ? _c('span', [_vm._v("国立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_type === 3) ? _c('span', [_vm._v("私立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_type === 4) ? _c('span', [_vm._v("その他")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appointment.school_name))]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.school_stage === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_stage === 1) ? _c('span', [_vm._v("小学")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_stage === 2) ? _c('span', [_vm._v("中学")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_stage === 3) ? _c('span', [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_stage === 4) ? _c('span', [_vm._v("幼稚園")]) : _vm._e(), _vm._v(" "), (_vm.appointment.school_stage === 5) ? _c('span', [_vm._v("その他")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 2) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 3) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 4) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 5) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.appointment.grade === 6) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.gender === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.gender === 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.appointment.gender === 2) ? _c('span', [_vm._v("女")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ名前")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_f_name) + " " + _vm._s(_vm.appointment.sub_l_name))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブかな")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_f_name_kana) + " " + _vm._s(_vm.appointment.sub_l_name_kana))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ 学校名 / 学年 / 性別")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.sub_school_type === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_type === 1) ? _c('span', [_vm._v("公立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_type === 2) ? _c('span', [_vm._v("国立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_type === 3) ? _c('span', [_vm._v("私立")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_type === 4) ? _c('span', [_vm._v("その他")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appointment.sub_school_name))]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.sub_school_stage === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_stage === 1) ? _c('span', [_vm._v("小学")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_stage === 2) ? _c('span', [_vm._v("中学")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_stage === 3) ? _c('span', [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_stage === 4) ? _c('span', [_vm._v("幼稚園")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_school_stage === 5) ? _c('span', [_vm._v("その他")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 2) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 3) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 4) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 5) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_grade === 6) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.sub_gender === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_gender === 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_gender === 2) ? _c('span', [_vm._v("女")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("駐車場")]), _vm._v(" "), (_vm.appointment.parking === 0) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.parking === 1) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("有")]) : _vm._e(), _vm._v(" "), (_vm.appointment.parking === 2) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("無")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("駐車場備考")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.parking_note))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("メイン成績")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.achievement))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("メイン習い事")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.learning))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("メイン / いつから")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.learning_start_period))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("メイン / きっかけ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.learning_nervous))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("メイン / 成果 / 継続")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.learning_result === 0) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_result === 1) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("上がった")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_result === 2) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("下がった")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_result === 3) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("変わらない")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_result === 4) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("わからない")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.learning_continuation === 0) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_continuation === 1) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("継続する")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_continuation === 2) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("継続しない")]) : _vm._e(), _vm._v(" "), (_vm.appointment.learning_continuation === 3) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("わからない")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ成績")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_achievement))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ習い事")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_learning))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ / いつから")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_learning_start_period))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ / きっかけ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sub_learning_nervous))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("サブ / 成果 / 継続")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.sub_learning_result === 0) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_result === 1) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("上がった")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_result === 2) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("下がった")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_result === 3) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("変わらない")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_result === 4) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("わからない")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.sub_learning_continuation === 0) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_continuation === 1) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("継続する")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_continuation === 2) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("継続しない")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sub_learning_continuation === 3) ? _c('span', {
    staticClass: "td"
  }, [_vm._v("わからない")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("同席者 / 父親の絡み")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('span', [_vm._v(_vm._s(_vm.appointment.attended))]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), (_vm.appointment.fathers_involvement === 0) ? _c('span', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.fathers_involvement === 1) ? _c('span', [_vm._v("有")]) : _vm._e(), _vm._v(" "), (_vm.appointment.fathers_involvement === 2) ? _c('span', [_vm._v("無")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("特記事項")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.notices))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("送るもの")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sending_products))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("送る方法")]), _vm._v(" "), (_vm.appointment.sending_method === 0) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sending_method === 1) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("郵送")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sending_method === 2) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("FAX")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sending_method === 3) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("MAIL")]) : _vm._e(), _vm._v(" "), (_vm.appointment.sending_method === 4) ? _c('div', {
    staticClass: "td"
  }, [_vm._v("持っていく")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("郵送・FAX / 予定日")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sending_date))])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("送信時間")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v(_vm._s(_vm.appointment.sending_time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("必ず確認してメモを取ってもらう事")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.user.office_id === 2) ? [(_vm.appointment.transmission_item_company === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_company === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 会社の正式名称は伝えたか？（株式会社エイト）\n        ")] : (_vm.user.office_id === 3) ? [(_vm.appointment.transmission_item_company === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_company === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 会社の正式名称は伝えたか？（株式会社よんろく）\n        ")] : [(_vm.appointment.transmission_item_company === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_company === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 会社の正式名称は伝えたか？（株式会社マスターマインズ）\n        ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.transmission_item_course === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_course === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 【家庭教師だけの指導】と【テキストを使う指導】の2通りある事を伝えたか？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.transmission_item_visitor === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_visitor === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 体験学習には実際の先生ではなくADが行くことは伝えたか？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.transmission_item_purpose === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_purpose === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 家庭教師及びテキスト販売契約について勧誘する目的は伝えたか？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [(_vm.appointment.transmission_item_requiredtime === 0) ? _c('span', [_vm._v("×")]) : _vm._e(), (_vm.appointment.transmission_item_requiredtime === 1) ? _c('span', [_vm._v("○")]) : _vm._e(), _vm._v(" 体験は2時間であることは伝えたか？\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("備考")]), _vm._v(" "), _c('div', {
    staticClass: "td",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.appointment.note))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("最寄駅")]), _vm._v(" "), _c('div', {
    staticClass: "td",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "outline": "0"
    },
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("徒歩移動時間")]), _vm._v(" "), _c('div', {
    staticClass: "td",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "outline": "0"
    },
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("年代")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("学生・社会人")])])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("終電")]), _vm._v(" "), _c('div', {
    staticClass: "td",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "outline": "0"
    },
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("泊まり ○ or ×")]), _vm._v(" "), _c('div', {
    staticClass: "td",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "outline": "0"
    },
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("送迎")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("必要・不要")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("教師性別")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("男性限定OK・女性限定OK・性別指定不可")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("交通費")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("送迎が付く場合 ~  __________円・送迎が付かない場合 ~ __________円")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("探し期間")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("2週間・3週間・4週間")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("その他")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_vm._v("長期決まるまで短期派遣の可能性有り")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v("教師数が少ないので条件内の紹介が出来ない可能性有り")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v("週2希望の場合は先生2人体制・連日指導の可能性有り")])]), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v("全条件(年齢・曜日・時間帯)広くないと紹介不可")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e4d1306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Print/PrintAp.vue
// module id = 1323
// module chunks = 0